// extracted by mini-css-extract-plugin
export default {"wrapper":"MinimizedBox_wrapper__CcSDJ"};